<template>
<div class="sponsor">
<h1 data-aos="fade" data-aos-delay="50"
    data-aos-duration="1000" ><strong>Sponsors</strong></h1>
<br>
<br>
<h3 data-aos="fade" data-aos-delay="50"
    data-aos-duration="1000" >League Partners</h3>
<div class="container partners" data-aos="fade" data-aos-delay="50"
    data-aos-duration="1000" >
    <a href="https://mlh.io/"><img src="@/assets/mlh.svg" width="200px" height="200px" class="col-lg-4 col-md-4 col-sm-6"></a>
</div>
<br><br>
<h3 data-aos="fade" data-aos-delay="50"
    data-aos-duration="1000" >Gold</h3>
<div class="container partners" data-aos="fade" data-aos-delay="50"
    data-aos-duration="1000" >
<a href="https://devfolio.co/"><img src="@/assets/devfolio.png" width="250px" height="200px" class="col-lg-3 col-md-3 col-sm-6"></a>
<a href="https://matic.network/"><img src="@/assets/matic.svg" width="200px" height="200px" class="col-lg-3 col-md-3 col-sm-6"></a>
<a href="https://fold.money/"><img src="@/assets/fold.png" height="100px" width="100px" class="col-lg-3 col-md-3 col-sm-6"></a>
<a href="https://www.portis.io/"><img src="@/assets/portis.svg" height="100px" width="100px" class="col-lg-3 col-md-3 col-sm-6"></a>
<a href="https://tezos.com/"><img src="@/assets/tezos.png" height="100px" width="100px" class="col-lg-3 col-md-3 col-sm-6"></a>
<a href="https://www.wolfram.com/"><img src="@/assets/wolfram.png" height="100px" width="100px" class="col-lg-3 col-md-3 col-sm-6"></a>
<a href="https://www.echoar.xyz/"><img src="@/assets/echoar.png" height="100px" width="100px" class="col-lg-3 col-md-3 col-sm-6"></a>
<a href="https://www.digitalocean.com/"><img src="@/assets/digitalocean.svg" height="150px" width="150px" class="col-lg-3 col-md-3 col-sm-6"></a>
<a href="https://repl.it/"><img src="@/assets/repl.svg" height="150px" width="150px" class="col-lg-3 col-md-3 col-sm-6"></a>
<a href="https://bubble.io/"><img src="@/assets/bubble.svg" height="150px" width="150px" class="col-lg-3 col-md-3 col-sm-6"></a>
<a href="https://hackclub.com/bank/"><img src="@/assets/hackclubbank.svg" height="150px" width="150px" class="col-lg-3 col-md-3 col-sm-6"></a>
</div>
<br>
<h3 data-aos="fade" data-aos-delay="50"
    data-aos-duration="1000" >Silver Plus</h3>
<div class="container partners" data-aos="fade" data-aos-delay="50"
    data-aos-duration="1000" >
    <a href="https://balsamiq.com/"><img src="@/assets/balsamiq.svg" width="200px" height="200px" class="col-lg-3 col-md-3 col-sm-6"></a>
    <a href="https://www.sashido.io/"><img src="@/assets/shashido.jpeg" width="200px" height="200px" class="col-lg-3 col-md-3 col-sm-6"></a>
    <a href="https://gen.xyz/"><img src="@/assets/xyz.png" width="200px" height="200px" class="col-lg-3 col-md-3 col-sm-6"></a>
    <a href="https://www.voiceflow.com/"><img src="@/assets/voiceflow.webp" width="200px" height="200px" class="col-lg-3 col-md-3 col-sm-6"></a>
    <a href="http://hackp.ac/mlh-stickermule-hackathons"><img src="@/assets/stickermule.png" width="200px" height="200px" class="col-lg-4 col-md-4 col-sm-6"></a>
</div>
<h3 data-aos="fade" data-aos-delay="50"
    data-aos-duration="1000" >Silver</h3>
<div class="container partners" data-aos="fade" data-aos-delay="50"
    data-aos-duration="1000" >
    <a href="https://www.jetbrains.com/"><img src="@/assets/jetbrains.png" width="200px" height="200px" class="col-lg-3 col-md-3 col-sm-6"></a>
    <a href="https://www.bugsee.com/"><img src="@/assets/bugsee.png" width="200px" height="200px" class="col-lg-3 col-md-3 col-sm-6"></a>
    <a href="https://www.interviewcake.com/"><img src="@/assets/interviewcake.webp" width="200px" height="200px" class="col-lg-3 col-md-3 col-sm-6"></a>
</div>
<h3 data-aos="fade" data-aos-delay="50"
    data-aos-duration="1000" >Bronze</h3>
<div class="container partners" data-aos="fade" data-aos-delay="50"
    data-aos-duration="1000" >
    <a href="https://www.linode.com/"><img src="@/assets/linode.png" width="100px" height="100px" class="col-lg-3 col-md-3 col-sm-6"></a>
    <a href="https://1password.com/"><img src="@/assets/1P.png" width="100px" height="100px" class="col-lg-1 col-md-1 col-sm-6"></a>
    <a href="https://magoosh.com/"><img src="@/assets/magoosh.png" width="100px" height="100px" class="col-lg-3 col-md-3 col-sm-6"></a>
    <a href="https://www.clerky.com/"><img src="@/assets/clerky.svg" width="100px" height="100px" class="col-lg-3 col-md-3 col-sm-6"></a>
</div>
<br><br>
<h3 data-aos="fade" data-aos-delay="50"
    data-aos-duration="1000" >Event Partners</h3>
    <br><br>
<div class="container partners" data-aos="fade" data-aos-delay="50"
    data-aos-duration="1000" >
    <a href="https://givemycertificate.com/"><img src="@/assets/givemycertificate.webp" width="100px" height="100px" class="col-lg-2 col-md-2 col-sm-6"></a>
    <a href="https://zubi.io/"><img src="@/assets/zubi.png" width="100px" height="100px" class="col-lg-2 col-md-2 col-sm-6"></a>
    <a href="https://streamyard.com/"><img src="https://streamyard.com/static/img/6f3cb5cde113ee25325a48a16e256a67.svg" width="100px" height="100px" class="col-lg-2 col-md-2 col-sm-6"></a>
    <a href="https://gotechnica.org/"><img src="@/assets/technica.png" width="100px" height="100px" class="col-lg-2 col-md-2 col-sm-6"></a>
    <a href="#"><img src="@/assets/happinessclub.webp" width="100px" height="100px" class="col-lg-2 col-md-2 col-sm-6"></a>
</div>
<br><br>
<h3 data-aos="fade" data-aos-delay="50"
    data-aos-duration="1000" >Community Partners</h3>
<div class="container partners" data-aos="fade" data-aos-delay="50"
    data-aos-duration="1000" >
    <a href="https://www.meetup.com/GDGNewDelhi/"><img src="@/assets/gdgdelhi.png" width="100px" height="100px" class="col-lg-2 col-md-2 col-sm-6"></a>
    <a href="https://www.hackathonsinternational.com/"><img src="@/assets/hackathoninternational.png" width="200px" height="200px" class="col-lg-2 col-md-2 col-sm-6"></a>
    <a href="https://www.meetup.com/GDG-Chandigarh/"><img src="@/assets/gdgc.png" width="200px" height="200px" class="col-lg-2 col-md-2 col-sm-6"></a>
    <a href="http://gdgjalandhar.com/"><img src="@/assets/gdgjalandhar.webp" width="200px" height="200px" class="col-lg-2 col-md-2 col-sm-6"></a>
    <a href="https://www.coffeehours.club/"><img src="@/assets/coffeehours.png" width="200px" height="200px" class="col-lg-2 col-md-2 col-sm-6"></a>
    <a href="https://in.linkedin.com/in/ieee-chandigarh-university-student-branch-6997721a7"><img src="@/assets/ieee.webp" width="200px" height="200px" class="col-lg-2 col-md-2 col-sm-6"></a>
    <a href="https://codeforcause.org/"><img src="@/assets/codeforcause.webp" width="200px" height="200px" class="col-lg-2 col-md-2 col-sm-6"></a>
    <a href="https://www.facebook.com/Amazon-Alexa-Developer-Community-CU-824539504565110/"><img src="@/assets/alexa.png" width="200px" height="200px" class="col-lg-3 col-md-3 col-sm-6"></a>
    <a href="https://www.meetup.com/tfugmumbai/"><img src="@/assets/tensorflow.webp" width="200px" height="200px" class="col-lg-3 col-md-3 col-sm-6"></a>
    <a href="https://techphantoms.onrender.com/"><img src="@/assets/techphantoms.svg" width="200px" height="200px" class="col-lg-3 col-md-3 col-sm-6"></a>
    <a href="http://www.defhacks.io/"><img src="@/assets/defhacks.png" width="200px" height="200px" class="col-lg-3 col-md-3 col-sm-6"></a>
    <a href="https://progate.com/"><img src="@/assets/progate.png" width="200px" height="200px" class="col-lg-3 col-md-3 col-sm-6"></a>
    <a href="https://www.codeasylums.com/"><img src="@/assets/codeasylum.png" width="200px" height="200px" class="col-lg-3 col-md-3 col-sm-6"></a>
    <a href="https://neuralhacks.org/"><img src="@/assets/neuralhacks.jpeg" width="200px" height="200px" class="col-lg-3 col-md-3 col-sm-6"></a>
    <a href="https://www.hackcbs.tech/"><img src="@/assets/hackcbs.png" width="200px" height="200px" class="col-lg-3 col-md-3 col-sm-6"></a>
</div>
<br><br>
<h3 data-aos="fade" data-aos-delay="50"
    data-aos-duration="1000" >Hiring Partners</h3>
<div class="container partners" data-aos="fade" data-aos-delay="50"
    data-aos-duration="1000" >
    <a href="https://openwatervc.com/"><img src="@/assets/openwater.svg" width="100px" height="100px" class="col-lg-2 col-md-2 col-sm-6"></a>
</div>
<br><br>
<h3 data-aos="fade" data-aos-delay="50"
    data-aos-duration="1000" >Gifting Partners</h3>
<div class="container partners" data-aos="fade" data-aos-delay="50"
    data-aos-duration="1000" >
    <a href="https://www.thesouledstore.com/"><img src="@/assets/souled.png" width="200px" height="200px" class="col-lg-2 col-md-2 col-sm-6"></a>
</div>
<br>
</div>
</template>

<script>
export default {

}
</script>

<style scoped>
.sponsor{
    background-color: #82CAE4;
}

h1,h3{
    color: black;
    text-align: center;
}

img{
    object-fit: contain;
    /* filter: grayscale(100%); */
    transition: filter 1s ease;
}

img:hover{
    filter: grayscale(0%);
      animation: bounce; /* referring directly to the animation's @keyframe declaration */
  animation-duration: 1s; /* don't forget to set a duration! */
}

/* svg{
    width: 20%;
    height: 20%;
} */

p{
    font-weight: bold;
    font-size: 2.0em;
    color: white;
    text-align: center;
}

.partners{
    text-align: center;
}

</style>
